module.exports = __webpack_public_path__ + "static/media/hug.e27a3e2c.svg";